// SUPSupplierOnboard.js
import React, { useState, useEffect } from 'react';
import '../AddGardenerForm.css';
import '../Buttons.css';
import api from '../../api';
import SupplierPolicy, { POLICY_TEXT } from '../Utilities/SupplierPolicy';
import './SUPSupplierOnboard.css';


const SUPSupplierOnboard = ({ handleUpdateSupplier, handleTabChange, currentDate }) => {

    // Supplier state
    const [supplier, setSupplier] = useState({
        name: '',
        email: '',
        phone: '',
        addressID: '',
        logoURL: '',
        website: '',
        catchmentIDs: [], // multiple locations
        streetAddress: '',
        city: '',
        province: '',
        postalCode: '',
        country: '',
        userid: '',
        hasStripePayout: 'false',
        stripeStatus: 'not_created'
    });

    const [locations, setLocations] = useState([]);
    const [step, setStep] = useState(1);
    const [progressCount, setProgressCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [currentSupplier, setCurrentSupplier] = useState(null);
    const [policyAgreed, setPolicyAgreed] = useState(false);
    const [showStripeModal, setShowStripeModal] = useState(false);


    useEffect(() => {
        const onboardingDone = sessionStorage.getItem("stripeOnboardingComplete");
        const verificationDone = sessionStorage.getItem("stripeVerificationComplete");

        if (onboardingDone) {
            fetchCurrentSupplier().then(updated => {
                if (updated.stripeStatus !== "connected") {
                    setShowStripeModal(true);
                    return;
                } else {
                    handleTabChange("Home", true);
                }
            });

            sessionStorage.removeItem("stripeOnboardingComplete");
            return;
        }

        if (verificationDone) {
            fetchCurrentSupplier().then(updated => {
                  handleTabChange("Home", true);
            });

            sessionStorage.removeItem("stripeVerificationComplete");
            return;
        }

        // normal onboarding initialization here
        fetchCurrentSupplier();
    }, []);


    // Fetch locations for catchment
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await api.get('/locations/all');
                setLocations(response.data);
            } catch (err) {
                console.error('Error fetching locations:', err);
            }
        };

        fetchLocations();
    }, []);

    // Fetch current supplier info on component mount
    useEffect(() => {
        fetchCurrentSupplier();
    }, []);

 //   useEffect(() => {
  //      if (currentSupplier?.hasStripePayout) {
     //       setStep(7);
      //  }
//}, [currentSupplier]);

    useEffect(() => {
        if (currentSupplier?.stripeStatus === 'connected' && step === 7) {
            handleTabChange('Home', true);
        }
    }, [currentSupplier, step]);


    const fetchCurrentSupplier = async () => {
        try {
            console.log('[redacted]: /api/supplier/current');
            const response = await api.get('/supplier/current');

            const data = response.data;
            setCurrentSupplier(data);
            setSupplier(prev => ({
                ...prev,          // keep initialized defaults
                ...data,          // overwrite with backend data
                catchmentIDs: Array.isArray(data.catchmentIDs) ? data.catchmentIDs : [], // ensure array
                plant: '',
                userid: data.id
            }));
            return data;
        } catch (err) {
            if (err.response?.status === 404) {
                setCurrentSupplier(null); // No supplier found
            }
            console.error('Error fetching current supplier:', err);
            return null;
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setSupplier((prev) => ({
            ...prev,
            [name]: value
        }));

    };

    const handleSubmit = async () => {
        try {

            // 1. Attach all plants
            const plantDataRes = await api.post('/supplierPlants/addAll', {
                supplierID: currentSupplier.id
            });

            console.log('Supplier plants attached:', plantDataRes.data);

        } catch (plantErr) {
            console.error('Failed to attach plants: ', plantErr);

        }

        try {
            // 2. Build Catchment
            const locationRes = await api.post('/supplier/catchment', {
                supplierID: currentSupplier.id,
                catchmentIDs: supplier.catchmentIDs
            });

            console.log('Supplier catchments attached:', locationRes.data);

            //handleTabChange('Home', true);
            setStep(7);

        } catch (err) {
            console.error('Error onboarding supplier:', err);
        }
    };

    const handleCatchmentChange = (e) => {
        const options = Array.from(e.target.selectedOptions);
        const values = options.map((opt) => opt.value);
        setSupplier((prev) => ({
            ...prev,
            catchmentIDs: values
        }));
    };

    const nextStep = async (e) => {
        e.preventDefault();
        let missingMessage = '';

        if (step === 1 && !supplier.email) {
            missingMessage = 'Email is required for your account.';
        } else if (step === 2 && !supplier.phone) {
            missingMessage = 'Phone number is required.';
        } else if (step === 3 && !supplier.website) {
            missingMessage = 'Website is required.';
        /*} else if (step === 4 && !supplier.logoURL) {
            missingMessage = 'Logo is required.';*/
        } else if (step === 5 && !supplier.streetAddress) {
            missingMessage = 'Street address is required.';
        } else if (step === 6 && supplier.catchmentIDs.length === 0) {
            missingMessage = 'Please select at least one catchment location.';
        }

        if (missingMessage) {
            alert(missingMessage);
            return;
        }

        try {

            // Step 5: Create the address first, then update supplier with addressID
            if (step === 5) {
                 const addressRes = await api.post('/addresses', {
                     streetAddress: supplier.streetAddress,
                     city: supplier.city,
                     province: supplier.province,
                     postalCode: supplier.postalCode,
                     country: supplier.country
                 });

                 supplier.addressID = addressRes.data.id;

            } 

            // Persist supplier info after each other step
            await handleUpdateSupplier(supplier);
            
        } catch (err) {
            console.error('Failed to update supplier during onboarding:', err);
        }

        if (step < 7) {
            setStep(prev => prev + 1);
            setProgressCount(prev => prev + 1);
        } else {
            const updated = await fetchCurrentSupplier();

            if (updated?.stripeStatus === 'connected') {
                handleTabChange('Home', true);
            } else {
                alert("Stripe account not connected yet. Please finish onboarding in Stripe.");
            }
        }
    };

    const prevStep = () => {
        if (step > 1) {
            setStep(prev => prev - 1);
            setProgressCount(prev => Math.max(prev - 1, 0));
        }
    };

    const handleStripeConnectOnboarding = async () => {
        try {
            const res = await api.post('/stripePayment/create-connect-account', {
                email: supplier.email
            });

            window.location.href = res.data.url;

        } catch (err) {
            console.error('Error starting Stripe onboarding:', err);
            alert('Failed to start Stripe onboarding.');
        }
    };

    const handleStripeVerification = async () => {
        try {
            const res = await api.post('/stripePayment/account-verification');
            window.location.href = res.data.url;
        } catch (err) {
            console.error('Error starting Stripe verification:', err);
            alert('Failed to start Stripe verification.');
        }
    };

    const handlePolicyAgree = async () => {
        try {
            await api.post('/supplier/policy-agree', {
                userID: currentSupplier.userid,
                policyVersion: "2026-04",
                policyText: POLICY_TEXT // import or inline
            });

            setPolicyAgreed(true);
        } catch (err) {
            console.error('Failed to save policy agreement:', err);
            alert('Could not save agreement.');
        }
    };


    return (
        <div className="add-supplier-form-container">
            <div className="add-supplier-form">
                <h1 className="onboarding-heading">{currentSupplier?.name || 'Supplier'} Onboarding</h1>
                <p className="onboarding-subheading">
                    Let's get your profile set up.
                </p>
                <div className="progress-tracker">
                    <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${(progressCount / 6) * 100}%` }} />
                    </div>
                    <p className="progress-text">
                        Completed {progressCount} of 6
                    </p>
                </div>

                <form id="supplier-form" onSubmit={(e) => e.preventDefault()}>
                    {step === 1 && (
                        <div>
                            <label>Email:</label>
                            <input
                                type="email"
                                name="email"
                                value={supplier.email}
                                onChange={handleChange}
                                required
                                autoFocus
                            />
                            <button type="button" className="button" onClick={nextStep}>Next</button>
                        </div>
                    )}

                    {step === 2 && (
                        <div>
                            <label>Phone:</label>
                            <input
                                type="tel"
                                name="phone"
                                value={supplier.phone}
                                onChange={handleChange}
                                required
                                autoFocus
                            />
                            <button type="button" className="button" onClick={nextStep}>Next</button>
                        </div>
                    )}
                    {step === 3 && (
                        <div>
                            <label>Website:</label>
                            <input
                                type="url"
                                name="website"
                                value={supplier.website}
                                onChange={handleChange}
                                required
                                autoFocus
                            />
                            <button type="button" className="button" onClick={nextStep}>Next</button>
                        </div>
                    )}
                    {step === 4 && (
                        <div>
                            <label>Logo URL:</label>
                            <input
                                type="text"
                                name="logoURL"
                                value={supplier.logoURL}
                                onChange={handleChange}
                                required
                                autoFocus
                            />
                            <button type="button" className="button" onClick={nextStep}>Next</button>
                        </div>
                    )}

                    {step === 5 && (
                        <div>
                            <label>Street Address:</label>
                            <input
                                type="text"
                                name="streetAddress"
                                value={supplier.streetAddress}
                                onChange={handleChange}
                                required
                                autoFocus
                            />

                            <label>City:</label>
                            <input
                                type="text"
                                name="city"
                                value={supplier.city}
                                onChange={handleChange}
                                required
                            />

                            <label>Province / State:</label>
                            <input
                                type="text"
                                name="province"
                                value={supplier.province}
                                onChange={handleChange}
                                required
                            />

                            <label>Postal Code:</label>
                            <input
                                type="text"
                                name="postalCode"
                                value={supplier.postalCode}
                                onChange={handleChange}
                                required
                            />

                            <label>Country:</label>
                            <input
                                type="text"
                                name="country"
                                value={supplier.country}
                                onChange={handleChange}
                                required
                            />

                            <button type="button" className="button" onClick={nextStep}>Next</button>
                        </div>
                    )}

                    {step === 6 && (
                        <div>
                            <label>Catchment Areas:</label>
                            <p className="helper-text">
                                Select all locations your supplier covers. Hold Ctrl (Cmd on Mac) to select multiple.
                            </p>
                            <select
                                name="catchmentIDs"
                                multiple
                                value={supplier.catchmentIDs}
                                onChange={handleCatchmentChange}
                            >
                                {locations.map((loc) => (
                                    <option key={loc.id} value={loc.id}>
                                        {loc.city}, {loc.province}, {loc.postalCode}, {loc.country}
                                    </option>
                                ))}
                            </select>
                            <button type="button" className="button" onClick={handleSubmit}>Save & Continue to Stripe Setup</button>
                        </div>
                    )}

                    {step === 7 && (
                        <div className="policy-step">
                            <h3>Supplier Agreement</h3>
                            <p className="helper-text">
                                Please review and agree to the Supplier Participation Agreement before continuing.
                            </p>

                            <div className="policy-box">
                                <SupplierPolicy />
                            </div>

                            {!policyAgreed && (
                                <button
                                    type="button"
                                    className="button agree-button"
                                    onClick={handlePolicyAgree}
                                >
                                    I Agree to the Supplier Participation Agreement
                                </button>
                            )}

                            {policyAgreed && (
                                <div className="stripe-section">
                                    <h3>Stripe Payout Setup</h3>
                                    <p>To receive payouts, you must complete Stripe's secure onboarding.</p>

                                    <button
                                        type="button"
                                        className="button"
                                        onClick={handleStripeConnectOnboarding}
                                    >
                                        Set Up Stripe Payouts
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {currentSupplier?.stripeStatus === 'connected' && (
                        <p className="success">Stripe account connected.</p>
                    )}

                    {isLoading && (
                        <div className="inline-progress-bar">
                            <div className="bar">
                                <div className="fill" />
                            </div>
                            <p>Saving supplier info...</p>
                        </div>
                    )}
                    {showStripeModal && (
                        <div className="modal-overlay">
                            <div className="modal">
                                <h2>Step 1 Complete</h2>
                                <p>Your Stripe account has been created, but Stripe still needs a few verification steps before payouts can be enabled.</p>
                                <p>This is normal - Stripe requires identity and address verification.</p>

                                <button
                                    className="button"
                                    onClick={handleStripeVerification}
                                >
                                    Continue Stripe Verification
                                </button>

                                <button
                                    className="button secondary"
                                    onClick={() => setShowStripeModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}

                </form>
            </div>
        </div>
    );
};

export default SUPSupplierOnboard;
